export enum MediaType {
  Unknown,
  Electronic,
  HardDrive,
  Cvd,
  All,
  NetworkDelivery
}
